<template>
    <div class="stat-card-wrapper">
        <div class="stat-card">
            <!-- Si hay número, mostrarlo grande -->
            <div v-if="hasNumber" class="stat-number">
                {{ formatNumber(Math.round(displayValue)) }}
            </div>

            <!-- Texto descriptivo -->
            <div v-if="text" class="stat-text">
                {{ text }}
            </div>

            <!-- Si no hay contenido -->
            <div v-if="!hasContent" class="stat-placeholder">
                Sin datos
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatCard',
    props: {
        number: {
            type: [Number, String],
            required: false,
            default: null
        },
        text: {
            type: String,
            required: false,
            default: ''
        }
    },
    data() {
        return {
            displayValue: 0,
            intervalId: null
        };
    },
    mounted() {
        if (this.hasNumber) {
            this.animateValue(0, this.number);
        }
    },
    beforeUnmount() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
    computed: {
        hasNumber() {
            return this.number !== null && this.number !== undefined && this.number !== '';
        },
        hasContent() {
            return this.hasNumber || (this.text && this.text.trim() !== '');
        }
    },
    methods: {
        formatNumber(num) {
            if (num === null || num === undefined || num === '') return '';
            return new Intl.NumberFormat('es-CO', {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            }).format(num);
        },
        animateValue(start, end) {
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            start = Number(start);
            end = Number(end);
            const duration = Math.min(1000 + Math.log10(end) * 200, 2000);
            const frameRate = 30;
            const totalFrames = Math.round((duration / 1000) * frameRate);
            let currentFrame = 0;
            const increment = (end - start) / totalFrames;
            this.displayValue = start;
            this.intervalId = setInterval(() => {
                currentFrame++;
                this.displayValue = start + increment * currentFrame;
                if (currentFrame >= totalFrames) {
                    clearInterval(this.intervalId);
                    this.displayValue = end;
                }
            }, duration / totalFrames);
        }
    },
    watch: {
        number: {
            handler(newValue) {
                if (this.hasNumber) {
                    this.animateValue(this.displayValue, newValue);
                }
            },
        },
    }
}
</script>

<style scoped>
.stat-card-wrapper {
    display: inline-block;
}

.stat-card {
    background: rgba(207, 220, 229, 0.945);
    border: 2px solid rgba(255, 255, 255, 1);
    border-radius: 25px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 10px;
}

.stat-number {
    color: rgba(4, 55, 61, 1);
    font-family: Poppins;
    font-weight: bold;
    font-size: 40px;
    line-height: 1;
}

.stat-text {
    color: rgba(4, 55, 61, 1);
    font-family: Poppins;
    font-weight: medium;
    font-size: 16px;
    line-height: 1.2;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.stat-placeholder {
    font-size: 14px;
    color: #6b7280;
    font-style: italic;
}

/* Para pantallas medianas */
@media (max-width: 768px) {
    .stat-card {
       /*  min-width: 160px;
        min-height: 80px; */
        padding: 8px;
    }

    .stat-number {
        font-size: 40px;
    }

    .stat-text {
        font-size: 14px;
        -webkit-line-clamp: 2;
    }
}

/* Para pantallas pequeñas */
@media (max-width: 480px) {
    .stat-card {
       /*  min-width: 120px;
        min-height: 60px; */
        padding: 6px;
    }

    .stat-number {
        font-size: 30px;
    }

    .stat-text {
        font-size: 12px;
        -webkit-line-clamp: 1;
    }
}
</style>